import { useGetControlStats } from "@/spz-api/controls/controls";
import type { GetControlStatsType } from "@/spz-api/model";
import { useMemo } from "react";
import { useLoaderData } from "react-router";

export const selectControlStatsViewModel = (
  selectedType: GetControlStatsType,
) => {
  const { controlId } = useLoaderData();
  const controlStatsQuery = useGetControlStats(controlId, {
    type: selectedType,
  });

  const isEmpty = useMemo(() => {
    return (
      controlStatsQuery.data &&
      (!controlStatsQuery.data.data.distributions ||
        !controlStatsQuery.data.data.population)
    );
  }, [controlStatsQuery.data]);

  return {
    stats: {
      loading: controlStatsQuery.isPending,
      data: controlStatsQuery.data?.data,
      error: controlStatsQuery.isError,
      refetch: controlStatsQuery.refetch,
      isEmpty,
      isEmptyOrError: controlStatsQuery.isError || isEmpty,
    },
  };
};
